<template>
  <div class="wt-form-inputs-container">

  <!--  <div class="wt-form-inputs-title">
      <div class="title">筛选查询</div>
      <div class="buttons">
        <template v-if="!$slots.buttons">
          <el-button size="small" type="primary" @click="toSearch">搜索</el-button>
          <el-button size="small" @click="toReset">重置</el-button>
          <el-button size="small" @click="toMore" v-show="isHasMoreButtons()">
            {{isMoreHidden?'更多搜索':'隐藏更多搜索'}}
          </el-button>
        </template>
        <slot name="buttons"></slot>
      </div>
    </div> -->
    <div class="wt-form-inputs-content" v-if="form.formInputsData && form.formInputsData.length > 0">
      <el-form size="small" :inline="true" class="wt-form-inputs">
        <template v-if="!$slots.default">
          <template v-for="item in form.formInputsData">
            <!--全部自定义数据不刷新-->
            <slot v-if="item.type === 'customAllFixed'" :name="item.key" v-show="isItemShow(item)"></slot>
            <!--全部自定义-->
            <slot v-if="item.type === 'customAll'" :name="item.key" v-show="isItemShow(item)"></slot>
            <el-form-item v-else :label="item.name + '：'" v-show="isItemShow(item)" :key="item.name">
              <!--日期选择-->
              <el-date-picker v-if="item.type === 'datetime'" v-model="item.value"
                              type="datetimerange" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" range-separator="至"
                              start-placeholder="开始日期" end-placeholder="结束日期" :default-time="['00:00:00', '23:59:59']" :unlink-panels="true">
              </el-date-picker>
              <!--下拉选择-->
              <el-select v-else-if="item.type === 'select'" v-model="item.value" :placeholder="item.placeholder ? item.placeholder : '请选择' + item.name" @change="handleChange(item)" :filterable="item.filterable">
                <el-option v-for="(dataItem, dataIndex) in item.data" :key="dataIndex" :label="dataItem.label"
                           :value="dataItem.value"></el-option>
              </el-select>
              <!--自定义-->
              <slot v-else-if="item.type === 'custom'" :name="item.key"></slot>
              <!-- 区域值 -->
              <div v-else-if="item.type === 'goodsRange'" class="spec-goods-range">
                <el-input v-model="item.value[0]" placeholder="请输入最小值"></el-input>
                <span>-</span>
                <el-input v-model="item.value[1]" placeholder="请输入最大值"></el-input>
              </div>
              <div v-else-if="item.type === 'cascader'">
                <el-cascader v-model="item.value" collapse-tags :options="item.options" :props="item.props" @change="handleChange(item)" :filterable="item.filterable" clearable></el-cascader>
              </div>
              <el-date-picker v-else-if="item.type === 'date'" v-model="item.value"
                              type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd" :placeholder="item.placeholder ? item.placeholder : '请输入' + item.name">
              </el-date-picker>
              <!--文本输入-->
              <el-input v-else v-model="item.value" :placeholder="item.placeholder ? item.placeholder : '请输入' + item.name"></el-input>
            </el-form-item>
          </template>
        </template>
        <slot name="default"></slot>
      <el-form-item v-if="form.formTableProp ? !form.formTableProp.searchButtonHidden : true">
        <el-button size="small" type="primary" @click="toSearch">搜索</el-button>
        <el-button size="small" @click="toReset">重置</el-button>
      </el-form-item>
      </el-form>
    </div>

  </div>
</template>

<script>
export default {
  name: 'wt-form-inputs',
  props: ['form'],
  data() {
    return {
      isMoreHidden: true
    }
  },
  methods: {
    toSearch() {
      //  点击查询
      this.form.pageData.currentPage = 0
      this.$emit('request-form-list')
    },
    toReset() {
      //  点击重置
      this.form.formInputsData.forEach(item => {
        if (item.type === 'datetime') {
          item.value = []
        } else if (item.type === 'customAllFixed') {
          // 数据不刷新
        } else if (item.type === 'goodsRange') {
          item.value = ['', '']
        } else if (typeof item.value === 'object') {
          item.value = []
        } else {
          item.value = ''
        }
        if (item.relateField && item.relateField.length && item.relateFieldData) {
          delete item.relateFieldData
        }
      })
      this.$emit('update:form.formInputsData', this.form.formInputsData)
      this.$emit('to-reset')
      this.$emit('request-form-list')
    },
    handleChange(item) {
      this.$emit('search-change-event', item)
      if (item.relateField && item.relateField.length) {
        if (item.type === 'cascader') {
          const options = []
          this.getRelateField(item.props.children, options, item.options)
          const el = options.find(iitem => { return item.value === iitem[item.props.value] })
          if (el) {
            item.relateFieldData = {}
            for (const i of item.relateField) {
              item.relateFieldData[i] = el[i]
            }
          } else {
            item.relateFieldData = {}
          }
        }
      }
    },
    getRelateField(cKey, res, data) {
      for (const item of data) {
        res.push(item)
        if (item[cKey] && item[cKey].length) {
          this.getRelateField(cKey, res, item[cKey])
        }
      }
    },
    toMore() {
      this.isMoreHidden = !this.isMoreHidden
    },
    isItemShow(item) {
      // 如果hidden属性为true，则隐藏该项
      if (item.hidden) {
        return false
      }
      if (item.display !== 'more') {
        return true
      }
      return !this.isMoreHidden
    },
    isHasMoreButtons() {
      if (this.form.formInputsData && this.form.formInputsData.length > 0) {
        let result = false
        this.form.formInputsData.forEach((item) => {
          if (item.display === 'more') {
            result = true
            return false
          }
        })
        return result
      }
      return false
    }
  }
}
</script>

<style lang="scss">
.spec-goods-range {
  border: 1px solid #DCDFE6;
  border-radius: 4px;
  .el-input {
    width: 150px;
    .el-input__inner {
      border: 0;
    }
  }
}
</style>
